// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__UBbvg","text":"styles_text__GIACg","skeleton-animation":"styles_skeleton-animation__Ddzal"};